import { render, staticRenderFns } from "./ListVehiclePage.vue?vue&type=template&id=3ffb5bcc"
import script from "./ListVehiclePage.vue?vue&type=script&lang=js"
export * from "./ListVehiclePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports